import React from 'react'
import { Label as ShadcnLabel } from '@/components/ui/label'
import { cn } from '@/lib/utils'

interface FormGroupProps extends React.HTMLAttributes<HTMLDivElement> {
  check?: boolean
  row?: boolean
}

export const FormGroup: React.FC<FormGroupProps> = ({ check, row, className, ...props }) => (
  <div className={cn('mb-4', check && 'flex items-center gap-2', row && 'flex flex-wrap items-center', className)} {...props} />
)

interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  check?: boolean
  for?: string
  sm?: number
  md?: number
}

export const Label: React.FC<LabelProps> = ({ className, check, sm, md, ...props }) => (
  <ShadcnLabel className={cn(check && 'font-normal', className)} {...props} />
)

interface FormFeedbackProps extends React.HTMLAttributes<HTMLDivElement> {
  valid?: boolean
}

export const FormFeedback: React.FC<FormFeedbackProps> = ({ valid, className, children, ...props }) => (
  <p className={cn('text-sm mt-1', valid ? 'text-[hsl(var(--success))]' : 'text-destructive', className)} {...props}>
    {children}
  </p>
)

interface FormTextProps extends React.HTMLAttributes<HTMLSmallElement> {}

export const FormText: React.FC<FormTextProps> = ({ className, ...props }) => (
  <small className={cn('text-sm text-muted-foreground', className)} {...props} />
)
